if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      console.log(evt, "ADD EVENT")

      const bundleKey = `bundle_${new Date().getTime()}`; // Example unique key using timestamp

      let portafilterId = null;
      let parentVariantId = null
      let upsellParentVariantId = document.querySelector('input[name="upsell-parent-variant-id"]');

      if (!this.closest('cart-drawer')){ 
          parentVariantId = document.querySelector('input[name="parent-variant-id"]');
          portafilterId = document.querySelector('input.portafilter-swatch:checked');
      }
      const upchargePortafilter = document.querySelector('input[name="portafilter"]:checked')?.getAttribute('upcharge')

       if (portafilterId) {
            let portafilterName = document.querySelector('.portafilter_label .color__bold');
            portafilterName ? formData.append('properties[Includes]', `${portafilterName.innerHTML} Portafilter`) : null
            formData.append('properties[_main_baristina_sku]', true);
            formData.append('properties[_portafilter_id_]', portafilterId ? portafilterId.getAttribute('portafilterid') : null);
            formData.append('properties[_bundle_key]', bundleKey); // Add unique bundle key
            upchargePortafilter ? formData.append('properties[_upcharge]', true) : null;
            upchargePortafilter ? formData.append('properties[_upcharge_price]', upchargePortafilter) : null;
        }

        let giftDataElement = null;

        if (evt.target.parentElement.hasAttribute('data-upsell-id')) {
            giftDataElement = JSON.parse(evt.target.nextSibling.textContent);
        } else {
            giftDataElement = JSON.parse(document.querySelector('#giftData').textContent);
        }
    
        if (giftDataElement) {
          giftDataElement.gifts.length > 0 ? formData.append('properties[_gift_id]', JSON.stringify(giftDataElement.gifts)) : null ;
          giftDataElement.gifts.length > 0 ? formData.append('properties[_bundle_key]', bundleKey) : null; 
          formData.append(`properties[Gift]`, "")
        }

      // Determine if we're on the cart page and adjust logic accordingly
      const isCartPage = window.location.pathname === '/cart';

      if (!isCartPage && this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers:  config.headers,
        body:  config.body
      })
        .then((response) => 
             response.json()
        )
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location.reload();
            return;
          }
        
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    } 

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
